import { NavLink } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import desktopTestimonialImage from "assets/images/referrals/testimonial-desktop.png";
import tabletTestimonialImage from "assets/images/referrals/testimonial-tablet.png";
import mobileTestimonialImage from "assets/images/referrals/testimonial-mobile.png";
import "./index.scss";

export const ReferralProgramTestimonial = () => {
  return (
    <section
      className="referal-program-testimonial-container"
      data-testid="referal-program-testimonial"
    >
      <h2 className="testimonial-title">
        The more friends you refer, the more money you earn!
      </h2>
      <picture className="testimonial-image-container">
        <source srcSet={desktopTestimonialImage} media="(min-width: 1200px)" />
        <source srcSet={tabletTestimonialImage} media="(min-width: 768px)" />
        <img
          src={mobileTestimonialImage}
          alt="Referal program testimonial"
          className="testimonial-image"
        />
      </picture>
      <NavLink className="testimonial-anchor" to={INTERNAL_PATHS.MY_REFERRALS}>
        INVITE FRIENDS NOW
      </NavLink>
    </section>
  );
};
